import React from 'react';
import ReactDOM from 'react-dom/client';
import 'normalize.css';
import './index.css';
import { App } from './App';
import { Provider } from 'react-redux';
import { store } from './store/index';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

export const rootPortal = document.getElementById('portal') as HTMLElement;

root.render(
  <Provider store={store}>
    <App />
  </Provider>

);
